export default __webpack_public_path__ + "static/media/react.fac641ea.jpg";